/** @format */

// import React from 'react'
import React, { Component } from "react";
import {
	Container,
	Row,
	Col,
	Breadcrumb,
	BreadcrumbItem,
	Card,
	CardHeader,
	CardBody,
	CardText,
	Form,
	FormGroup,
	Label,
	Input,
	FormText,
	Button,
} from "reactstrap";
import Header from "../components/LoginHeader";
import Footer from "../components/LoginFooter";
import Forgot from "../containers/forgot";
// import Link from 'next/link'
export async function getStaticProps() {
	return {
		props: {
			title: "Customer login",
		},
	};
}

class forgotpassword extends Component {
	render() {
		return (
			<React.Fragment>
				<Header />
				
				<section className='pb-5' style={{ width: "100%"}}>
					<Container className='mt-5 col align-self-center'>
						<div className="col">
							<Forgot history={this.props.history}/>
						</div>
					</Container>
				</section>
				<Footer footerResize={true}/>
			</React.Fragment>
		);
	}
}

export default forgotpassword;
